import { post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";

export async function submitJobData(jobId, step) {
    console.log("step", step);

    let allItems = JSON.parse(localStorage.getItem("data"))[jobId];
    if (allItems && Object.keys(allItems).length > 1) {
        const result = await post(`/jobs/${jobId}`, {
            data: JSON.stringify(allItems),
        });
        if (step != "-1") {
            if (result && result.success) {
                notify("تغییرات با موفقیت ذخیره شد", "success");
            } else {
                notify("در ذخیره سازی اطلاعات خطایی رخ داد", "error");
            }
        }
    }
}
